/* eslint-disable prefer-destructuring */
/* eslint-disable import/prefer-default-export */

const APP_URL = process.env.GATSBY_APP_URL;

export const URL = {
  auth: `${APP_URL}auth/`,
};
